import React from 'react';
import PropTypes from 'prop-types';
import ArticleModal from '../../organisms/Dialogs/ArticleModal';
import ArticleEditModal from '../../organisms/Dialogs/ArticleEditModal';
import TagDialog from '../../organisms/TagDialog';
import AddToCollectionDialog from '../../organisms/Dialogs/AddToCollectionDialog';
import BulkEditArticlesDialog from '../../organisms/Dialogs/BulkEditArticlesDialog';
import RemoveTagsDialog from '../../organisms/Dialogs/RemoveTagsDialog';
import RemoveFromCollectionDialog from '../../organisms/Dialogs/RemoveFromCollectionDialog';
import ConfirmDialog from '../../molecules/ConfirmDialog/ConfirmDialog';
import SentimentPropagationDialog from '../../molecules/SentimentPropagationDialog';
import TagPropagationDialog from '../../molecules/TagPropagationDialog';
import ModernToast from '../../molecules/ModernToast';
import BackgroundScrapingModal from '../../organisms/Dialogs/BackgroundScrapingModal';
import PendingPrintsModal from '../../organisms/Dialogs/PendingPrintsModal';
import QuickNewsletterDialog from '../../organisms/Dialogs/QuickNewsletterDialog/QuickNewsletterDialog';
import BulkSentimentDialog from './BulkSentimentDialog';

const ArticleListDialogs = ({
  selectedArticle,
  selectedIndex,
  articlesCount,
  modalOpen,
  onCloseModal,
  onArticleUpdated,
  onToggleFavorite,
  onToggleReadArticle,
  onUpdateSentiment,
  onPrevArticle,
  onNextArticle,
  onAddTags,
  onRemoveArticleTag,
  onEdit,
  onDeleteArticle,
  onSendNewsletter,
  availableTags,
  editModalOpen,
  onCloseEditModal,
  onSaveArticle,
  onSelectArticle,
  onRemoveTag,
  tagDialogOpen,
  onCloseTagDialog,
  articleForTags,
  bulkTagDialogOpen,
  onCloseBulkTagDialog,
  onBulkAddTags,
  bulkEditDialogOpen,
  onCloseBulkEditDialog,
  selectedArticles,
  bulkActionLoading,
  onApplyBulkFieldEdit,
  collectionDialogOpen,
  onCloseCollectionDialog,
  articlesToAddToCollection,
  onCollectionSuccess,
  removeTagsDialogOpen,
  onCloseRemoveTagsDialog,
  onRemoveTagsSuccess,
  removeFromCollectionsDialogOpen,
  onCloseRemoveFromCollectionsDialog,
  onRemoveFromCollectionsSuccess,
  sentimentDialogOpen,
  onCloseBulkSentiment,
  bulkSentiment,
  onBulkSentimentChange,
  onConfirmBulkSentiment,
  onAnalyzeSentimentBulk,
  aiSentimentEnabled,
  showBackgroundScraping,
  scrapingModalOpen,
  onCloseScrapingModal,
  onRestoreScrapingModal,
  onBackgroundScrapingJobStarted,
  pendingPrintsModalOpen,
  onClosePendingPrintsModal,
  onPrintsUpdated,
  confirmDialog,
  onCancelConfirmDialog,
  propagationDialogOpen,
  onPropagationClose,
  onPropagationConfirm,
  onPropagationCancel,
  pendingSentiment,
  similarArticles,
  propagationDialogLoading,
  tagPropagationDialogOpen,
  onTagPropagationClose,
  onTagPropagationConfirm,
  onTagPropagationCancel,
  pendingTagsToPropagate,
  similarArticlesForTags,
  tagPropagationLoading,
  snackbar,
  onCloseSnackbar,
  quickNewsletterOpen,
  onCloseQuickNewsletter,
  quickNewsletterArticles,
  onQuickNewsletterEmailSent
}) => (
  <>
    <ArticleModal
      article={selectedArticle}
      open={modalOpen}
      onClose={onCloseModal}
      onArticleUpdated={onArticleUpdated}
      onToggleFavorite={onToggleFavorite}
      onToggleRead={onToggleReadArticle}
      onUpdateSentiment={onUpdateSentiment}
      leftArrow={selectedIndex > 0}
      rightArrow={selectedIndex < articlesCount - 1}
      onPrev={onPrevArticle}
      onNext={onNextArticle}
      onAddTags={onAddTags}
      onRemoveTag={onRemoveArticleTag}
      onEdit={onEdit}
      onDelete={onDeleteArticle}
      onSendNewsletter={onSendNewsletter}
      availableTags={availableTags}
    />

    <ArticleEditModal
      article={selectedArticle}
      open={editModalOpen}
      onClose={onCloseEditModal}
      onSave={onSaveArticle}
      onSelectArticle={onSelectArticle}
      onAddTags={onAddTags}
      onRemoveTag={onRemoveTag}
      availableTags={availableTags}
      key={`edit-modal-${selectedArticle?._id || 'new'}-${editModalOpen ? 'open' : 'closed'}`}
    />

    <TagDialog
      open={tagDialogOpen}
      onClose={onCloseTagDialog}
      onAddTags={(tags) => {
        if (articleForTags?._id) {
          onAddTags(articleForTags._id, tags);
        }
      }}
      availableTags={availableTags}
      mode="both"
    />

    <TagDialog
      open={bulkTagDialogOpen}
      onClose={onCloseBulkTagDialog}
      onAddTags={onBulkAddTags}
      availableTags={availableTags}
      mode="both"
    />

    <BulkEditArticlesDialog
      open={bulkEditDialogOpen}
      onClose={onCloseBulkEditDialog}
      articleIds={selectedArticles}
      loading={bulkActionLoading}
      onApply={onApplyBulkFieldEdit}
    />

    <AddToCollectionDialog
      open={collectionDialogOpen}
      onClose={onCloseCollectionDialog}
      articleIds={articlesToAddToCollection}
      onSuccess={onCollectionSuccess}
    />

    <RemoveTagsDialog
      open={removeTagsDialogOpen}
      onClose={onCloseRemoveTagsDialog}
      articleIds={selectedArticles}
      onSuccess={onRemoveTagsSuccess}
    />

    <RemoveFromCollectionDialog
      open={removeFromCollectionsDialogOpen}
      onClose={onCloseRemoveFromCollectionsDialog}
      articleIds={selectedArticles}
      onSuccess={onRemoveFromCollectionsSuccess}
    />

    <BulkSentimentDialog
      open={sentimentDialogOpen}
      onClose={onCloseBulkSentiment}
      selectedCount={selectedArticles.length}
      sentiment={bulkSentiment}
      onSentimentChange={onBulkSentimentChange}
      onManualApply={onConfirmBulkSentiment}
      onAnalyzeWithAI={onAnalyzeSentimentBulk}
      loading={bulkActionLoading}
      aiEnabled={aiSentimentEnabled}
    />

    {showBackgroundScraping && (
      <BackgroundScrapingModal
        open={scrapingModalOpen}
        onClose={onCloseScrapingModal}
        onRestore={onRestoreScrapingModal}
        onJobStarted={onBackgroundScrapingJobStarted}
      />
    )}

    <PendingPrintsModal
      open={pendingPrintsModalOpen}
      onClose={onClosePendingPrintsModal}
      onPrintsUpdated={onPrintsUpdated}
    />

    <ConfirmDialog
      open={confirmDialog.open}
      title={confirmDialog.title}
      message={confirmDialog.message}
      onConfirm={confirmDialog.onConfirm}
      onCancel={onCancelConfirmDialog}
      confirmText={confirmDialog.confirmText || 'Confirmar'}
      cancelText="Cancelar"
    />

    <SentimentPropagationDialog
      open={propagationDialogOpen}
      onClose={onPropagationClose}
      onConfirm={onPropagationConfirm}
      onCancel={onPropagationCancel}
      sentiment={pendingSentiment || 'neutral'}
      similarArticles={similarArticles}
      loading={propagationDialogLoading}
    />

    <TagPropagationDialog
      open={tagPropagationDialogOpen}
      onClose={onTagPropagationClose}
      onConfirm={onTagPropagationConfirm}
      onCancel={onTagPropagationCancel}
      tags={pendingTagsToPropagate}
      similarArticles={similarArticlesForTags}
      loading={tagPropagationLoading}
    />

    <ModernToast
      open={snackbar.open}
      message={snackbar.message}
      severity={snackbar.severity}
      onClose={onCloseSnackbar}
      duration={2500}
      position="bottom-center"
    />

    <QuickNewsletterDialog
      open={quickNewsletterOpen}
      onClose={onCloseQuickNewsletter}
      articles={quickNewsletterArticles}
      onEmailSent={onQuickNewsletterEmailSent}
    />
  </>
);

ArticleListDialogs.propTypes = {
  selectedArticle: PropTypes.object,
  selectedIndex: PropTypes.number.isRequired,
  articlesCount: PropTypes.number.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onArticleUpdated: PropTypes.func,
  onToggleFavorite: PropTypes.func.isRequired,
  onToggleReadArticle: PropTypes.func.isRequired,
  onUpdateSentiment: PropTypes.func.isRequired,
  onPrevArticle: PropTypes.func.isRequired,
  onNextArticle: PropTypes.func.isRequired,
  onAddTags: PropTypes.func.isRequired,
  onRemoveArticleTag: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDeleteArticle: PropTypes.func.isRequired,
  onSendNewsletter: PropTypes.func.isRequired,
  availableTags: PropTypes.array.isRequired,
  editModalOpen: PropTypes.bool.isRequired,
  onCloseEditModal: PropTypes.func.isRequired,
  onSaveArticle: PropTypes.func.isRequired,
  onSelectArticle: PropTypes.func.isRequired,
  onRemoveTag: PropTypes.func.isRequired,
  tagDialogOpen: PropTypes.bool.isRequired,
  onCloseTagDialog: PropTypes.func.isRequired,
  articleForTags: PropTypes.object,
  bulkTagDialogOpen: PropTypes.bool.isRequired,
  onCloseBulkTagDialog: PropTypes.func.isRequired,
  onBulkAddTags: PropTypes.func.isRequired,
  bulkEditDialogOpen: PropTypes.bool.isRequired,
  onCloseBulkEditDialog: PropTypes.func.isRequired,
  selectedArticles: PropTypes.array.isRequired,
  bulkActionLoading: PropTypes.bool.isRequired,
  onApplyBulkFieldEdit: PropTypes.func.isRequired,
  collectionDialogOpen: PropTypes.bool.isRequired,
  onCloseCollectionDialog: PropTypes.func.isRequired,
  articlesToAddToCollection: PropTypes.array.isRequired,
  onCollectionSuccess: PropTypes.func.isRequired,
  removeTagsDialogOpen: PropTypes.bool.isRequired,
  onCloseRemoveTagsDialog: PropTypes.func.isRequired,
  onRemoveTagsSuccess: PropTypes.func.isRequired,
  removeFromCollectionsDialogOpen: PropTypes.bool.isRequired,
  onCloseRemoveFromCollectionsDialog: PropTypes.func.isRequired,
  onRemoveFromCollectionsSuccess: PropTypes.func.isRequired,
  sentimentDialogOpen: PropTypes.bool.isRequired,
  onCloseBulkSentiment: PropTypes.func.isRequired,
  bulkSentiment: PropTypes.string.isRequired,
  onBulkSentimentChange: PropTypes.func.isRequired,
  onConfirmBulkSentiment: PropTypes.func.isRequired,
  onAnalyzeSentimentBulk: PropTypes.func.isRequired,
  aiSentimentEnabled: PropTypes.bool.isRequired,
  showBackgroundScraping: PropTypes.bool.isRequired,
  scrapingModalOpen: PropTypes.bool.isRequired,
  onCloseScrapingModal: PropTypes.func.isRequired,
  onRestoreScrapingModal: PropTypes.func.isRequired,
  onBackgroundScrapingJobStarted: PropTypes.func.isRequired,
  pendingPrintsModalOpen: PropTypes.bool.isRequired,
  onClosePendingPrintsModal: PropTypes.func.isRequired,
  onPrintsUpdated: PropTypes.func.isRequired,
  confirmDialog: PropTypes.object.isRequired,
  onCancelConfirmDialog: PropTypes.func.isRequired,
  propagationDialogOpen: PropTypes.bool.isRequired,
  onPropagationClose: PropTypes.func.isRequired,
  onPropagationConfirm: PropTypes.func.isRequired,
  onPropagationCancel: PropTypes.func.isRequired,
  pendingSentiment: PropTypes.string,
  similarArticles: PropTypes.array.isRequired,
  propagationDialogLoading: PropTypes.bool.isRequired,
  tagPropagationDialogOpen: PropTypes.bool.isRequired,
  onTagPropagationClose: PropTypes.func.isRequired,
  onTagPropagationConfirm: PropTypes.func.isRequired,
  onTagPropagationCancel: PropTypes.func.isRequired,
  pendingTagsToPropagate: PropTypes.array.isRequired,
  similarArticlesForTags: PropTypes.array.isRequired,
  tagPropagationLoading: PropTypes.bool.isRequired,
  snackbar: PropTypes.object.isRequired,
  onCloseSnackbar: PropTypes.func.isRequired,
  quickNewsletterOpen: PropTypes.bool.isRequired,
  onCloseQuickNewsletter: PropTypes.func.isRequired,
  quickNewsletterArticles: PropTypes.array.isRequired,
  onQuickNewsletterEmailSent: PropTypes.func.isRequired
};

ArticleListDialogs.defaultProps = {
  selectedArticle: null,
  articleForTags: null,
  onArticleUpdated: null,
  pendingSentiment: null
};

export default ArticleListDialogs;
